export default __webpack_public_path__ + "static/media/check-animation.5275497c.gif";